import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ThemeProvider } from 'react-jss';
import { ReactNotifications } from 'react-notifications-component';
import { useFullscreen } from 'react-use';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
import { TourProvider } from '@reactour/tour';
import ThemeContext from '../contexts/themeContext';
import Aside from '../layout/Aside/Aside';
import Wrapper from '../layout/Wrapper/Wrapper';
import Portal from '../layout/Portal/Portal';
import { demoPages } from '../menu';
import { Toast, ToastContainer } from '../components/bootstrap/Toasts';
import useDarkMode from '../hooks/useDarkMode';
import COLORS from '../common/data/enumColors';
// import { getOS } from '../helpers/helpers';
import steps, { styles } from '../steps';
import { userAuth } from '../contexts/userContext';
import { setIn } from 'formik';
import Loader from '../pages/common/vhelper/Loader';
import ErrorBoundary from '../pages/presentation/demo-pages/helper/ErrorBoundaries';
import UiModal from '../modal/Uimodal.js';
import apiServicewt from '../api/apiServicewt.js';
import { getConfig } from '../config';
import DueDateStatusLoader from '../components/extras/DueDateStatusLoader';
import { DueDateProvider } from '../contexts/dueDateContext';
import { LoginSettingsProvider } from '../contexts/loginSettingsContext';
import GlobalAlertListener from '../components/GlobalAlertListener';
import TourGuideProvider from '../contexts/tourGuideContext';
import { TourStatusProvider } from '../contexts/TourStatusContext';
import { GlobalLoadingSpinner, LoadingProvider } from '../contexts/LoadingContext';

const App = () => {
	const { themeStatus, darkModeStatus } = useDarkMode();

	const theme = {
		theme: themeStatus,
		primary: COLORS.PRIMARY.code,
		secondary: COLORS.SECONDARY.code,
		success: COLORS.SUCCESS.code,
		info: COLORS.INFO.code,
		warning: COLORS.WARNING.code,
		danger: COLORS.DANGER.code,
		dark: COLORS.DARK.code,
		light: COLORS.LIGHT.code,
	};

	useEffect(() => {
		if (darkModeStatus) {
			document.documentElement.setAttribute('theme', 'dark');
		}
		return () => {
			document.documentElement.removeAttribute('theme');
		};
	}, [darkModeStatus]);

	const { token, setToken } = useContext(userAuth);
	const navigate = useNavigate();
	const location = useLocation();
	const [loaderv, setLoaderv] = useState(false);

	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const ref = useRef(null);
	useFullscreen(ref, fullScreenStatus, {
		onClose: () => setFullScreenStatus(false),
	});

	useLayoutEffect(() => {
		if (process.env.REACT_APP_MODERN_DESGIN === 'true') {
			document.body.classList.add('modern-design');
		} else {
			document.body.classList.remove('modern-design');
		}
	});

	const withOutAsidePages = [
		demoPages.login.path,
		demoPages.signUp.path,
		demoPages.forgot.path,
		demoPages.changepw.path,
		demoPages.setup.path,
	];
	if (loaderv) {
		return <Loader />;
	}
	return (
		<ErrorBoundary>
			<ThemeProvider theme={theme}>
				<LoadingProvider>
					<LoginSettingsProvider>
						<DueDateProvider>
							<ToastProvider components={{ ToastContainer, Toast }}>
								<TourProvider
									steps={steps}
									styles={styles}
									showNavigation={false}
									showBadge={false}>
									<TourGuideProvider>
										<TourStatusProvider>
											<DueDateStatusLoader />
											<GlobalLoadingSpinner />
											<div
												ref={ref}
												className='app'
												style={{
													backgroundColor: darkModeStatus
														? 'var(--bs-body-bg)'
														: '#ececec',
													zIndex: fullScreenStatus && 1,
													overflow: fullScreenStatus && 'scroll',
												}}>
												<GlobalAlertListener />
												<Routes>
													{withOutAsidePages.map((path) => (
														<Route key={path} path={path} />
													))}
													<Route path='*' element={<Aside />} />
												</Routes>
												<Wrapper />
											</div>
											<Portal id='portal-notification'>
												<ReactNotifications />
											</Portal>
										</TourStatusProvider>
									</TourGuideProvider>
								</TourProvider>
							</ToastProvider>
						</DueDateProvider>
					</LoginSettingsProvider>
				</LoadingProvider>
			</ThemeProvider>
		</ErrorBoundary>
	);
};

export default App;
